import React from 'react';
import { formatPriceString } from 'common/helpers';

const Money: React.FC<{ children: any }> = (props: { children: any }) => {
  const result = <>{formatPriceString(props.children)}</>;

  return result;
};

export default Money;
